<!--
  Work Scope rich-text editor (30778). The editor AND its toolbar are authored
  together in this one template on purpose: Kendo's editor/toolbar content
  queries do not cross a view boundary, so the toolbar must live in the same
  view as the editor (see the component doc + spec). Keep the tool set in step
  with the LOCKED_OUT list in rich-text-toolbar-parity.spec.ts.
-->
<kendo-editor
  [class]="editorClass"
  [iframe]="false"
  [value]="workScope()"
  [disabled]="disabled()"
  (valueChange)="onValueChange($event)"
  (blur)="onTouched()"
>
  <kendo-toolbar>
    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button kendoEditorBoldButton />
      <kendo-toolbar-button kendoEditorItalicButton />
      <kendo-toolbar-button kendoEditorUnderlineButton />
      <kendo-toolbar-button kendoEditorStrikethroughButton />
    </kendo-toolbar-buttongroup>
    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button kendoEditorInsertUnorderedListButton />
      <kendo-toolbar-button kendoEditorInsertOrderedListButton />
      <kendo-toolbar-button kendoEditorIndentButton />
      <kendo-toolbar-button kendoEditorOutdentButton />
    </kendo-toolbar-buttongroup>
    <kendo-toolbar-buttongroup>
      <kendo-toolbar-button kendoEditorUndoButton />
      <kendo-toolbar-button kendoEditorRedoButton />
    </kendo-toolbar-buttongroup>
  </kendo-toolbar>
</kendo-editor>
